import { ContentNodeType } from "../../editor-config-context";
import { ContentNodeDefinition } from "../types";

const TagDefinition: ContentNodeDefinition = {
  nodeType: ContentNodeType.Tag,
  // Matches @@@tag:tagType:id:name:email:entityType:link@@@
  // Use a non-greedy match that stops at @@@ to handle @ in emails
  regex: /@@@tag:(.*?)@@@/g,
  toXML: content => {
    const match = content[1] ?? "";
    const parts = match.split(":");

    // parts[0] = tagType, parts[1] = id, parts[2] = name, parts[3] = email, parts[4] = entityType, parts[5] = link
    const [tagType, id, name, email, entityType, link] = parts;

    let props = `data-type="tagMention" data-tag-type="${tagType || "user"}"`;

    if (id) {
      props += ` data-id="${id}"`;
    }
    if (name) {
      props += ` data-name="${name}"`;
    }
    if (email) {
      props += ` data-email="${email}"`;
    }
    if (entityType) {
      props += ` data-entity-type="${entityType}"`;
    }
    if (link) {
      props += ` data-link="${link}"`;
    }

    return `<span ${props}></span>`;
  },
};

export default TagDefinition;
